import type {
  RestangularEmployee,
  RestangularPosition,
} from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.types';

export enum SectionPropertyName {
  cost = 'cost',
  laborPercentage = 'laborPercentage',
  totalOvertimeHours = 'totalOvertimeHours',
  paidMinutes = 'paidMinutes',
  totalOvertimeCost = 'totalOvertimeCost',
}

export type InformationBoxProps = {
  sectionValue: number;
  sectionPropertyName: SectionPropertyName;
  navigateTo: ({ route, routeParams }: { route: string; routeParams?: any }) => void;
  openAddShiftModal: () => void;
  hasVisitiedLaborCostSettingsTab: boolean;
  employees: RestangularEmployee[];
  positions: RestangularPosition[];
};
